import util from '@/common/util';
import {
    FETCH_SNAPSHOT_LISTINGS,
    FETCH_EVALUATION_ADDRESS
} from './_store/types';

export function asyncData(store) {
    
    const isCms = util.isSSRServer ? false : window?.sitePageAutoInit === false;
    let info = (this.listingDetail && this.listingDetail.info) || {};
    let params = {
        'sold-date': 180,
        includeStat: true,
        listingStatus: 'Sold'
    };
    if (info.subDivisionName) {
        params.key = info.subDivisionName;
        params.keywordType = 'subdivision';
    } else if (info.zipCode) {
        params.keywordType = 'zipCode';
        params.key = info.zipCode;
    }
    let ps = [];
    if ((params.key && params.key) || isCms) {
        ps.push(store[FETCH_SNAPSHOT_LISTINGS]({ params, isCms }));
    }

    let { cityAddress, streetAddress } = info;
    let addressParams = [cityAddress, streetAddress].filter(Boolean).join(', ');
    ps.push(store[FETCH_EVALUATION_ADDRESS](addressParams));
    return Promise.all(ps);
}
